let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bxBVU")).then(() => parcelRequire('hRHE3'));